// extracted by mini-css-extract-plugin
export var category = "news-card-module--category--7e81f";
export var image = "news-card-module--image--b9209";
export var link = "news-card-module--link--48083";
export var linkIcon = "news-card-module--linkIcon--5bb28";
export var root = "news-card-module--root--b549b";
export var text = "news-card-module--text--68607";
export var title = "news-card-module--title--bcec4";